module.exports = __webpack_public_path__ + "img/VM21_3098_low.e2797c3e.jpg";